var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Component } from 'react';
import { Nav } from '../nav';
import { services } from '@comall-backend-builder/core';
import { assign } from 'lodash';

var SideNav = function (_super) {
  __extends(SideNav, _super);

  function SideNav(props) {
    var _this = _super.call(this, props) || this;

    _this.handleOpenChange = function (openKeys) {
      var lastOpenKeys = _this.state.openKeys;
      var changedKey = openKeys.find(function (key) {
        return !lastOpenKeys.includes(key);
      });

      if (changedKey && _this.props.items.some(function (_a) {
        var key = _a.key;
        return key === changedKey;
      })) {
        _this.setState({
          openKeys: [changedKey]
        });
      } else {
        _this.setState({
          openKeys: openKeys
        });
      }
    };

    _this.state = {
      openKeys: []
    };
    return _this;
  }

  SideNav.prototype.componentDidMount = function () {
    this.updateMenuStatus();
  };

  SideNav.prototype.componentDidUpdate = function (lastProps) {
    if (this.props.location !== lastProps.location) {
      this.updateMenuStatus();
    }
  };
  /**
   * 根据当前路由来确定当前需要展开的 submenu
   */


  SideNav.prototype.updateMenuStatus = function () {
    var items = this.props.items;
    var openKeys = [];

    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
      var item = items_1[_i];

      if (item.type === 'menu') {
        openKeys = this.getOpenKeys(item);

        if (openKeys.length) {
          break;
        }
      }
    }

    this.setState({
      openKeys: openKeys
    });
  };

  SideNav.prototype.getOpenKeys = function (menu) {
    var items = menu.items,
        key = menu.key;
    var pathname;
    var location = this.props.location;

    if (location) {
      pathname = location.pathname;
    }

    for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
      var item = items_2[_i];

      if (item.type === 'menu') {
        var openKeys = this.getOpenKeys(item);

        if (openKeys.length) {
          return [key].concat(openKeys);
        }
      } else if (pathname && item.route && services.navigation.isPathMatched(pathname, item.route)) {
        return [key];
      }
    }

    return [];
  };

  SideNav.prototype.render = function () {
    var openKeys = this.state.openKeys;

    var _a = this.props,
        collapsed = _a.collapsed,
        otherProps = __rest(_a, ["collapsed"]);

    var mode = 'inline';

    var props = __assign(__assign({}, otherProps), {
      mode: mode,
      onOpenChange: this.handleOpenChange
    });

    if (!collapsed) {
      assign(props, {
        openKeys: openKeys
      });
    }

    return React.createElement(Nav, __assign({}, props));
  };

  return SideNav;
}(Component);

export { SideNav };